import type React from "react";

import { CalendarIcon } from "@/components/Icons/CalendarIcon";
import { Button } from "@/design-system/Button";
import { canManageAnyBookableAsset } from "@/helpers/permissions";
import { usePermission } from "@/hooks/usePermission";
import { useSlug } from "@/hooks/useSlug";
import { routes } from "@/routes";
import { useTranslation } from "@/translations";

import { canCreateNewServicePartner } from "../permissions";

type ServicesListActionProps = {
  entityType: "service" | "asset";
};

export function ServicesListAction({ entityType }: ServicesListActionProps): React.ReactNode {
  const { t } = useTranslation();
  const slug = useSlug();
  const hasPermission = usePermission();

  if (entityType === "service") {
    if (hasPermission(canCreateNewServicePartner)) {
      return (
        <Button type="link" href={routes.servicePartners.create({ slug })} data-testid="service-create-page-link">
          {t("model.service.action.new")}
        </Button>
      );
    }

    return null;
  }

  return (
    <>
      <Button
        type="link"
        href={`${routes.calendar.list({
          slug,
        })}?tab=reservations`}
        variant="soft"
        icon={<CalendarIcon />}
      >
        {t("page.bookings.list-assets.actions.see-reservations")}
      </Button>
      {hasPermission(canManageAnyBookableAsset) && (
        <Button type="link" href={routes.bookings.createAsset({ slug })} variant="filled">
          {t("page.bookings.list-assets.actions.new")}
        </Button>
      )}
    </>
  );
}
